import SongsAddMultiple from "./SongsAddMultiple";

export default function SongsAddAlbum() {
  return <SongsAddMultiple source="album" />;
}
